module.exports = __webpack_public_path__ + "static/media/signage-industrial-img31.afb26b5a.jpg";